import React, { useState, useRef } from "react";
import "./signUpPage-styles.css";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import Loading from "../SpinnerAndError/Loading";
import { Link } from "react-router-dom";
import Error from "../SpinnerAndError/Error";

let SignUpPage = () => {
  const [passwordInput, setPasswordInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [checkBoxClicked, setCheckboxClicked] = useState(false);
  const [loginSuccessful, setLoginSuccessful] = useState(false);
  const [userAlreadyExists, setUserAlreadyExists] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorLoader, setErrorLoader] = useState(false);

  let navigate = useNavigate();
  const scrollHere = useRef(null);

  const registerUrl = process.env.REACT_APP_REGISTER_URL;

  const bodyData = {
    email: emailInput,
    password: passwordInput,
  };

  const fetchData = async () => {
    try {
      let response = await fetch(registerUrl, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 201) {
        let data = await response.json();

        setLoading(false);
        if (data._id.length > 0) {
          setLoginSuccessful(true);
          setLoading(true);
          message.success({
            content: (
              <span>
                Thank you! We will now redirect you to Stripe in order to start
                your{" "}
                <span style={{ textDecoration: "underline" }}>
                  7 days free trial
                </span>
                .
              </span>
            ),
            duration: 10, // Duration in seconds
            style: {
              fontSize: "1.1em",
              fontWeight: "700",
            },
          });

          setTimeout(() => {
            /* BELOW IS FOR DIRECTING DIRECTLY TO STRIPE  */
            window.location.assign(
              process.env.REACT_APP_STRIPE_REGISTER_PAYMENT_LINK +
                "?prefilled_email=" +
                emailInput,
              { state: { verifyEmail: true } }
            );
            /*            window.location.assign("/"); */
          }, "3000");
        }
      } else if (response.status === 401) {
        console.log("User already exists.");
        setLoading(false);
        setUserAlreadyExists(true);
      }
    } catch (error) {
      console.log(error);
      console.log("Something went wrong.");
      setLoading(false);
      setErrorLoader(true);
    }
  };

  const onSubmitFunction = (event) => {
    event.preventDefault();
    setLoading(true);
    fetchData();
  };

  let checkBoxFunction = (event) => {
    setCheckboxClicked(!checkBoxClicked);
  };

  return (
    <>
      <div className="min-h-screen flex flex-col justify-center bg-gray-200 py-6">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          {userAlreadyExists && (
            <div className="text-center mb-4">
              <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded">
                User already exists. Please{" "}
                <Link
                  to="/"
                  className="text-indigo-600 hover:text-indigo-500 text-sm"
                >
                  login
                </Link>{" "}
                here.
              </div>
            </div>
          )}

          <div className="text-center mb-3">
            <h1 className="text-2xl font-bold text-black">Sign Up</h1>
          </div>

          <div className="mx-auto max-w-md bg-white p-6 rounded shadow-md">
            <form onSubmit={onSubmitFunction} className="space-y-4">
              <label className="block text-sm font-medium text-gray-600 mb-n1">
                Email
              </label>
              <input
                type="email"
                required
                onChange={(event) => setEmailInput(event.target.value)}
                className="w-full px-3 py-2 border rounded"
              />

              <label className="block text-sm font-medium text-gray-600 mb-n1">
                Password
              </label>
              <input
                type="password"
                required
                onChange={(event) => setPasswordInput(event.target.value)}
                className="w-full px-3 py-2 border rounded"
              />

              <div>
                <input
                  type="checkbox"
                  id="terms"
                  onChange={checkBoxFunction}
                  className="mr-2"
                />
                <label htmlFor="terms" className="text-sm">
                  I accept the{" "}
                  <Link
                    to="/terms"
                    className="text-indigo-600 hover:text-indigo-500 text-sm"
                  >
                    terms of use
                  </Link>{" "}
                  and the
                  <Link
                    to="/privacy-policy"
                    className="text-indigo-600 hover:text-indigo-500 text-sm ml-1"
                  >
                    privacy policy
                  </Link>
                </label>
              </div>

              {checkBoxClicked && !loading && !errorLoader ? (
                <button
                  type="submit"
                  className="w-full bg-green-500 text-white px-4 py-2 rounded mt-4 hover:bg-green-600"
                >
                  Sign Up
                </button>
              ) : checkBoxClicked && loading ? (
                <div className="flex justify-center items-center h-full">
                  <Loading />
                </div>
              ) : checkBoxClicked && errorLoader && !loading ? (
                <Error />
              ) : (
                <button
                  type="submit"
                  className="w-full bg-green-500 text-white px-4 py-2 rounded mt-4 opacity-50 cursor-not-allowed"
                  disabled
                >
                  Sign Up
                </button>
              )}

              <div className="flex justify-center items-center h-full">
                <p className="text-sm mt-4">
                  Already have an account?
                  <Link
                    to="/"
                    className="text-indigo-600 hover:text-indigo-500 text-sm ml-2"
                  >
                    Login
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default SignUpPage;
